import { Component, OnInit, OnDestroy, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { ScreeningLight, ScreeningAdditionalData, ScreeningNote, AdverseActionLetterStats, Screening, ProcessorReportOpenBreadCrumb } from '../../models/screeningInvite';
import { DatePipe } from '@angular/common';
import { ScreeningService } from '../services/screening.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../../clients-module/services/client.service';
import { ToastrService } from 'ngx-toastr';
import { PhonePipe } from '../../pipes/phone.pipe';
import { ApplicantDataService } from '../../services/applicant-data.service';
import * as _ from 'lodash';
import { UserLight } from '../../users-module/models/userLight';
import { SearchRecord, SearchPackage } from '../../packages-module/models/searchPackage';
import { SearchPackageService } from '../../services/search-package.service';
import { UserService } from '../../users-module/services/user.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchAddDialogComponent } from 'src/app/packages-module/components/search-add-dialog/search-add-dialog.component';
import { ClientPackagePricing } from 'src/app/packages-module/models/clientPackagePrice';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { PrintQueueRequest } from 'src/app/models/printQueueRequest';
import { IssueDialogComponent } from 'src/app/issue-tracker/issue-dialog/issue-dialog.component';
import { SupportIssue, SupportIssueStatus } from 'src/app/issue-tracker/models/SupportIssue';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';
import { UserFilter } from 'src/app/users-module/models/userFilter';
import { tap, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ChannelService, ChannelEvent } from 'src/app/services/channel.service';
import { HardDeclineReason } from 'src/app/models/hardDeclineReason';
import { ScreeningEditComponent } from '../components/screening-edit/screening-edit.component';
import { ConsumerDisclosureStatRecord, ReportReleasedModel } from 'src/app/shared-components-module/change-log/change-log.component';
import { GridSettingsSummaryComponent } from 'src/app/screening-module/components/grid-settings-summary/grid-settings-summary.component';
import { DisputeTrackerService } from 'src/app/dispute-tracker/dispute-tracker.service';
import { ConsumerDispute, ConsumerDisputeIdentity } from 'src/app/dispute-tracker/models/consumerDispute';
import { DisputeModalComponent } from 'src/app/dispute-tracker/dispute-modal/dispute-modal.component';
import { ApplicantIdentity } from 'src/app/models/applicantIdentity';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { ArgyleComponent } from '../components/argyle/argyle.component';
import { environment } from 'src/environments/environment';
import { SopAssistantService } from 'src/app/services/sop-assistant.service';


@Component({
  selector: 'app-screening-view',
  templateUrl: './screening-view.component.html',
  styleUrls: ['./screening-view.component.less'],
  // animations:[    trigger('openClose', [
  //   // ...
  //   state('open', style({
  //     height: '200px',
  //     opacity: 1,
  //     backgroundColor: 'yellow'
  //   })),
  //   state('closed', style({
  //     height: '100px',
  //     opacity: 0.8,
  //     backgroundColor: 'blue'
  //   })),
  //   transition('open => closed', [
  //     animate('1s')
  //   ]),
  //   transition('closed => open', [
  //     animate('0.5s')
  //   ]),
  // ]),]
})
export class ScreeningViewComponent implements OnInit, OnDestroy {
  screeningId : number;
  screeningUpdate$ : Subscription;
  craUpdate$ : Subscription;
  requestingUser : UserLight;
  appliedPackage : SearchPackage;
  clientPricingModel : ClientPackagePricing;
  addNewNote : boolean = false;
  newNote : ScreeningNote;
  savingNote : boolean = false;
  modalRef : NgbModalRef;
  screeningLoaded : boolean = false;
  reportReleasing : boolean = false;
  onScreeningRefresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  onScreeningRelease: EventEmitter<ReportReleasedModel> = new EventEmitter<ReportReleasedModel>();
  public crimSearchETA: Date;
  public lastReleasedDate: string;
  @ViewChild('argyle') child!: ArgyleComponent;
  // Socket updates and timer
  cev : ChannelEvent[] = [];
  private timer: any; // timer for refreshing teh report after messages come in.
  private timeoutDuration = 3000; // 5 seconds timeout
  _groupedApplicants: Screening[] = [];
  isFFD: boolean = false;
  // RIQ-4642: Sibling screening functionality (updated to handle multiple siblings)
  siblingScreenings: ScreeningLight[] = [];
  // Existing dispute for this screening (if any)
  existingDispute: ConsumerDispute = null;

  public get screeningToEdit() : ScreeningLight {
    return this.screening.screenings[0];
  }

  //SCRSTP-1733: restrict showing of report view / print buttons based on the following criteria
  public get showReportViewButtons() : boolean {
    return (this.screeningToEdit && (this.screeningToEdit.reportStatus == 'Complete' || this.screeningToEdit.creditOnlyReport === true || this.auth.UserInRole('CRA')));
  }

  public get showGoToTNTButton() : boolean 
  {
    return (this.screeningToEdit && this.screeningToEdit.apiVendor == 0 && this.auth.UserInRole('CRA'));

  }

  
  public get showSnapptBanner() : boolean {
    try {
      return this.auth.UserInRole('CRA') && this.screeningToEdit && this.screeningToEdit.billingRule.ruleName.indexOf('Snappt') >= 0;
    } catch (error) {
      return false;
    }
    

  }

  public get showDIVBanner() : boolean {
    try {
      return this.screeningToEdit.argyleData?.argyleInvite != null;
    } catch (error) {
      return false;
    }
  }

  
   // Stranded close: IncomeMgr may POST complete-stranded; RIQUser is required so incomever/fetch populated argyleData.
   // Hide when invite already revoked (matches RevokeInvite outcome).
  public get showCompleteStrandedIncomeVerButton(): boolean {
    try {
      const hasRole = this.auth.UserInRole('IncomeMgr') || this.auth.UserInRole('CanCompleteIncomeVer');
      const inv = this.screeningToEdit?.argyleData?.argyleInvite;
      const isComplete = this.screeningToEdit?.reportStatus === 'Complete';
      const show = hasRole && !!inv && !isComplete;
      return show;
    } catch {
      return false;
    }
  }

  // RIQ-4642: Show sibling screening alert (updated for multiple siblings)
  public get showSiblingAlert() : boolean {
    return this.auth.UserInRole('CRA') && !!this.siblingScreenings?.length;
  }

  // Get dispute button text based on whether dispute exists
  public get disputeButtonText() : string {
    return this.screeningToEdit && this.screeningToEdit.hasDispute ? 'View Dispute' : 'Initiate Dispute';
  }
  

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: any) {
    // this.screening.AbandonReport(this.crumb).subscribe();
    navigator.sendBeacon(environment.baseURl + `/api/lookingglass/report/deactive`, JSON.stringify(this.crumb));
  }


  constructor(public datePipe: DatePipe,
    public screening : ScreeningService,
    public activatedRoute: ActivatedRoute,
    public auth : AuthService,
    public toast : ToastrService,
    public phonePipe : PhonePipe,
    private clients : ClientService,
    private location : Router,
    private appData : ApplicantDataService,
    public users : UserService,
    public searches : SearchPackageService,
    public filtering : FilteringService,
    private modalService: NgbModal,
    private channels : ChannelService,
    public groups: GroupApplicantsService,
    private disputeService: DisputeTrackerService,
    private sopAssistant: SopAssistantService)
    { }


  ngOnDestroy(): void {
    this.screening.screenings = [];
    this.groups.groupScreenings = [];
    this.users.userFilter = new UserFilter();
    if(this.screeningUpdate$) this.screeningUpdate$.unsubscribe();
    // this.screening.AbandonReport(this.crumb).subscribe();
    navigator.sendBeacon(environment.baseURl + `/api/lookingglass/report/deactive`, JSON.stringify(this.crumb));
  }

  public get groupedApplicants() : Screening[] {
    if(!this.groups.groupScreenings) return [];
    else return this.groups.groupScreenings.filter(g => g.id != this.screeningToEdit.id);
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      const routeId = parseInt(p.get('scrn'), 10);
      if (!isNaN(routeId)) {
        this.screeningId = routeId;
        this.sopAssistant.screeningId = routeId;
      }
      this.loadScreening();
    });

    // this.searchStatuses = Object.keys(SearchStatus).filter(k => typeof SearchStatus[k as any] === "number");
    if(this.auth.UserInRole('CRA')){
      this.craUpdate$ = this.channels.sub('cra-update').subscribe((ev: ChannelEvent)=>{
        var prsd = <ProcessorReportOpenBreadCrumb>JSON.parse(ev.data);
        if(prsd.screeningId == this.screeningToEdit.screeningId && prsd.userId != this.auth.loggedInUser.id){
          this.toast.warning(`${prsd.userName} Just opened this report`, 'Another User Has opened this report open',{ timeOut: 2000, closeButton: true })
        }
      })
    }
 
    this.screeningUpdate$ = this.channels.sub('ScreeningUpdate').subscribe((ev : ChannelEvent) =>{

      var parsed = JSON.parse(ev.data);  
      // console.warn(parsed);
      ev.data = parsed;
      var id = parsed.objectId;
        // if(parsed.propertyName == 'SearchEntryUpdate') console.log(ev); for debuggin
       
        if(id == this.screeningId) 
        {
          if (parsed.propertyName == 'residentIQ') {
            this.screening.pulsingText.residentIQ = true;
            this.screeningToEdit.residentIQ = parsed.newValue;
          }
          else if (parsed.propertyName == 'recommendedDecision') {
            this.screening.pulsingText.residentIQ = true;
            this.screeningToEdit.recommendedDecision = parsed.newValue;
          }
          else if (parsed.propertyName == "reportStatus") {
            this.screeningToEdit.reportStatus = parsed.newValue;
            // this.screeningToEdit.screeningStatus = parsed.newValue;
            this.screening.pulsingText.reportStatus = true;
            this.onScreeningRefresh.next(true);
          }
          else if(parsed.propertyName == "SearchEntryUpdate"){
            if(this.screeningToEdit && this.screeningToEdit.additionalData){
              let ass = this.screeningToEdit.additionalData.find(ase=>{return ase.searchEntryId == parsed.searchEntry.id; });
              ass.searchStatus = parsed.searchEntry.pipelineStage;
              ass.searchState = parsed.searchEntry.searchState;
              ass.updateFired = true;
            }
          }
          
          if(parsed.propertyName == "SearchesPaid"){
            this.RELOADScreening(true);
          }
          else{
            this.cev.push(ev);
            this.resetTimer();
          }
           
            // this.RELOADScreening();  
        } 
    });
  }

    // Reload timer for websocket updates so we can batch them up and only pull the report back when all the updates are done.
    private resetTimer(): void {
      this.reloading = true;
      // Clear the existing timer
      this.toast.info('RIQ is sending udpates from the calculators and event processors, give us a few seconds and the page will automatically reload for you when updates complete.',"Updates are coming in!");
      if (this.timer) {
        clearTimeout(this.timer);
      }
  
      // Start a new timer
      this.timer = setTimeout(() => {
        this.RELOADScreening();
        this.cev = [];
      }, this.timeoutDuration);
    }
 


    // // This is for debugging the UI updates on 3112
    // public releaseReportResults(): void {
    //   console.log(this.cev)
    // }

  public releaseReportResults(): void {
    //RIQ-1964: check to see if a report has unexcluded crim records.. if so, and recdec is not decline/rr, show the ConfirmRelease modal; otherwise, release normally
    this.appData.HasUnfilteredCriminalRecords(this.screeningToEdit.id).subscribe((res: boolean) => {
      if(res && !(this.screeningToEdit.recommendedDecision.toLocaleLowerCase() === "decline" || this.screeningToEdit.recommendedDecision.toLocaleLowerCase() === "review required")) {
        const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
        modalRef.componentInstance.name = 'ConfirmRelease';
        modalRef.componentInstance.title = "Confirm Report Release";
        modalRef.componentInstance.confirmButtonText = `Release as ${this.screeningToEdit.recommendedDecision}`;
        modalRef.componentInstance.cancelButtonText = "Change Decision";
        modalRef.componentInstance.alertBody = `You are attempting to release a report with visible criminal records on it with a decision of ${this.screeningToEdit.recommendedDecision}. Are you sure these records are not declinable (Decline) or that they don't need to be reviewed (Review Required)?`
        modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
          this.screening.releaseTntReportResults(this.screeningToEdit.id).subscribe((resp: any) => {
            this.reportReleasing = true;
            setTimeout(()=>{ 
              //if it's RMO, just hide the button. we should not release it again to prevent the PDFs from stacking up in that system
              if(this.screeningToEdit.apiVendor && this.screeningToEdit.apiVendor == 6) {
                this.reportReleasing = true;
                this.toast.info('This screening has been released to RMO. Releasing is temporarily disabled.', 'RMO Screening Released'); 
              }
              else
                this.reportReleasing = false;
            },5000);
        },
        err => {
          this.reportReleasing = false;
        },
        () => { this.RELOADScreening() });
        modalRef.dismiss();
        });
      }
      else {
        if(this.screeningToEdit)
        this.screeningToEdit.released = true;
      this.screening.releaseTntReportResults(this.screeningToEdit.id).subscribe((resp: any) => {
          this.reportReleasing = true;
          setTimeout(()=>{ 
            //if it's RMO, just hide the button. we should not release it again to prevent the PDFs from stacking up in that system
            if(this.screeningToEdit.apiVendor && this.screeningToEdit.apiVendor == 6) {
              this.reportReleasing = true;
              this.toast.info('This screening has been released to RMO. Releasing is temporarily disabled.', 'RMO Screening Released'); 
            }
            else
              this.reportReleasing = false;
          },5000);
          this.toast.success('Your screening has been released by the system.', 'Screening Released');
            
        },
        err => {
          this.reportReleasing = false;
        },
        () => { this.RELOADScreening(); });
      }
    })
  }

  screeningNoteAdded(scrn: ScreeningNote) {
    if(scrn.screeningId == this.screeningToEdit.id) {
      this.screeningToEdit.screeningNotes.push(scrn);
    }
  }


  reloading: boolean = false;
  RELOADScreening(reloadsearches: boolean = false) {
    // this.screeningLoaded = false;
    this.toast.info('Looks like your data got stale, let me freshen that up for you!.',"Reloading!");
    this.reloading = true;
    this.screening.FetchScreeningById(this.screeningId).pipe(take(1), tap((scn: ScreeningLight) => {
      let addy = this.screeningToEdit.additionalData;
      // this.screening.screenings = [];
      scn.hardDeclineReasons.forEach(hdr => {
        hdr = Object.assign(new HardDeclineReason(), hdr);
      });
      this.screening.screenings[0] = Object.assign(new ScreeningLight(), scn);
      this.screeningToEdit.additionalData = addy;
    })).subscribe(() => { },
      (error) => {
        this.screening.WriteLogToRIQ({
          loggerMessage: "SCRN-REFRESH-ERROR",
          err: error,
          scrn: this.screeningToEdit.screeningId,
          usr: this.auth.loggedInUser.userName
        })
        this.toast.error('There was an error loading your updates, Please refresh the page to get the latest report changes.', '', { disableTimeOut: true, closeButton: true })
      }, () => {

        this.screening.FetchCrimSearchETA(this.screeningToEdit.id).subscribe((res: Date) => {
          this.crimSearchETA = res
        });

        this.screening.FetchSupportingDocsSummary(this.screeningId).subscribe(res => {
          this.screeningToEdit.supportingDocs = res;
        },
          err => {
            this.toast.error('Error fetching applicant documents.', '', { closeButton: true, disableTimeOut: true });
          });

        if (this.screeningToEdit.coApp && this.screeningToEdit.groupId) {
          this.appData.GetGroupIncome(this.screeningToEdit.invitationId).pipe(take(1), tap((scc: any) => {
            if (scc) this.screeningToEdit.groupIncomeData = scc.income;
          }, (err: any) => {
          })).subscribe();

          this.child.loadSources();
          this.groups.getGroupedScreenings(this.screeningToEdit.groupId).pipe(tap((_ : Screening[]) => 
          { 
            _.forEach(it=>{
              let scr = new Screening(it);
              scr.hasUnverifiedIncome = this.hasUnverifiedIncome;
              this.groups.groupScreenings.push(scr);
            })
            // this.groups.groupScreenings = _;
            console.log(_); 
          })).subscribe();
    
        }

        // this.screening.getThreshholdRecommendation(this.screeningToEdit);

        if (reloadsearches) {
          this.screening.FetchScreeningAdditionalData(this.screeningToEdit.id).pipe(take(1), tap((scc: ScreeningAdditionalData[]) => {
            this.screeningToEdit.additionalData = scc.map(s => {
              return Object.assign(new ScreeningAdditionalData(), s);
            });
          })).subscribe();
        }
        this.reloading = false;
        this.onScreeningRefresh.next();
      })
  }

  completeStrandedIncomeVer(): void {
    const inv = this.screeningToEdit?.argyleData?.argyleInvite;
    const scrnId = this.screeningToEdit?.id;
    if (!inv?.id || !scrnId) {
      this.toast.warning('No income verification invite on this report.');
      return;
    }
    const mod = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
    mod.componentInstance.title = 'Close stuck income verification?';
    mod.componentInstance.confirmButtonText = 'Yes, close it';
    mod.componentInstance.cancelButtonText = 'Cancel';
    mod.componentInstance.alertBody =
      'Finishes income verification and revokes the Argyle invite.';
    mod.componentInstance.evnt.pipe(take(1)).subscribe((ok: boolean) => {
      if (!ok) {
        return;
      }
      this.appData.CompleteStrandedIncomeVer(scrnId, inv.id).pipe(take(1)).subscribe({
        next: () => {
          inv.inviteRevoked = true;
          if (inv.inviteStatus !== undefined) {
            inv.inviteStatus = 'revoked';
          }
          this.toast.success('Income verification completed.');
          this.modalService.dismissAll();
          this.onScreeningRefresh.emit(true);
          this.loadScreening();
          if (this.child) {
            this.child.loadIncomeVer();
          }
        },
        error: () => this.toast.error('Could not complete income verification.')
      });
    });
  }

  flagFFD(scrn: ScreeningLight): void {

    const mod = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
    mod.componentInstance.name = 'FFDModal';
    mod.componentInstance.title = "Flag report / identity as Full File Disclosure?";
    mod.componentInstance.confirmButtonText = "Yes, I'm sure";
    mod.componentInstance.cancelButtonText = "Cancel";
    mod.componentInstance.alertBody = "Marking a report as Full File Disclosure will automatically set the RecDec and PropDec to Review Required. " + 
      "Access to the report will be restricted, and all searches will be automatically completed. A dev will be required to clear this status if done by mistake.";
    mod.componentInstance.evnt.subscribe((ev:boolean)=>{
      this.screening.CreateFFDIdentity(scrn).pipe(tap((_ : Boolean) =>{
        if(_) {
          this.toast.success('Identity marked as FullFile Disclosure');
          this.modalService.dismissAll();
          this.location.navigateByUrl('/screenings');
        }
      }, 
      (err) => {
        this.toast.error('Error flagging FFD. Please notify support.')
      },
      () => {
  
      })).subscribe()
    });


  }

  crumb : ProcessorReportOpenBreadCrumb;
  loadScreening() {
    // this.screeningLoaded = false;
    this.screening.FetchScreeningById(this.screeningId).pipe(take(1), tap((scn: ScreeningLight) =>{
      this.screening.screenings = [];
      this.screening.screenings.push(Object.assign(new ScreeningLight(), scn));

      scn.hardDeclineReasons.forEach(hdr => {
        hdr = Object.assign(new HardDeclineReason(), hdr);
      });
     
    })).subscribe(() => { },
      (error) => {
        this.toast.error('Screening lookup failed.', '', { disableTimeOut: true, closeButton: true });
        this.screeningLoaded = false;
      },()=>{
        this.screeningLoaded = true;
        this.screening.ActivateReport(this.screeningToEdit.invitationId, this.screeningToEdit.screeningId, this.auth.loggedInUser.id, this.auth.loggedInUser.userName).subscribe((rslt: ProcessorReportOpenBreadCrumb[])=>{
          this.crumb = rslt.find(rs => {return rs.userId == this.auth.loggedInUser.id;});
          if(rslt.length > 1)
          {
            rslt.filter(rss=> {return rss.userId != this.auth.loggedInUser.id;}).forEach(el=>{
              this.toast.warning(`${el.userName} Currently has this report open`, 'Another User Has this report open!',{ timeOut: 2000, closeButton: true  })
            });
            
          }
        });
        this.screening.GetFFDIdentity(this.screeningToEdit.id).pipe(tap((_:boolean )=> this.isFFD = _)).subscribe();

        this.getRequestingUser(this.screeningToEdit.initiatingUser);
        //this.appData.GetIncomeVerificationData(this.screeningToEdit.screeningToken);
        this.screening.FetchCrimSearchETA(this.screeningToEdit.id).subscribe((res: Date) => {
          this.crimSearchETA = res
        });

        this.onScreeningRelease.subscribe((res: ReportReleasedModel) => {
          if(res)
            this.lastReleasedDate = res.releaseDate as string;
        },
        (err) => { },
        () => {});

        this.disputeService.checkDisputedIdentity(new ConsumerDisputeIdentity(
          this.screeningToEdit.applicantFirstName, this.screeningToEdit.applicantLastName, 
          this.screeningToEdit.applicantSSN, this.screeningToEdit.applicantDOB)).pipe(
            tap((_:boolean)=> {
              this.screeningToEdit.isDisputedScreening = _
            })).subscribe();

        // Load existing dispute if screening has one
        if (this.screeningToEdit.hasDispute) {
          this.disputeService.getDisputeByScreeningId(this.screeningId).subscribe(
            (dispute: ConsumerDispute) => {
              this.existingDispute = dispute;
            },
            (error) => {
              console.error('Error loading existing dispute:', error);
            }
          );
        }

        // RIQ-4642: Get sibling screening reports from optimized stats table (NEW OPTIMIZED METHOD)
        this.screening.getSiblingScreenings(this.screeningToEdit.id).subscribe(results => {
          this.siblingScreenings = results || [];
        });
          
  
        this.screening.FetchSupportingDocsSummary(this.screeningId).subscribe(res => {
          this.screeningToEdit.supportingDocs = res;
        },
          err => {
            this.toast.error('Error fetching applicant documents.', '', { closeButton: true, disableTimeOut: true });
          });
  
        if (this.screeningToEdit.coApp && this.screeningToEdit.groupId) {
          this.appData.GetGroupIncome(this.screeningToEdit.invitationId).pipe(take(1), tap((scc: any) => {
            if (scc) this.screeningToEdit.groupIncomeData = scc.income;
          }, (err: any) => {
          })).subscribe();

          this.groups.getGroupedScreenings(this.screeningToEdit.groupId).pipe(tap((_ : Screening[]) => 
          { 
            _.forEach(it=>{
              let scr = new Screening(it);
              scr.hasUnverifiedIncome = this.hasUnverifiedIncome;
              this.groups.groupScreenings.push(scr);
            })
            // console.log(_); 
          })).subscribe();
    
        }
        
        
          this.screening.FetchScreeningAdditionalData(this.screeningToEdit.id).pipe(take(1),tap((scc: ScreeningAdditionalData[]) => {
            this.screeningToEdit.additionalData = scc.map(s => {
              return Object.assign(new ScreeningAdditionalData(), s);
            });
          })).subscribe();
        
      

        this.searches.FetchSearchPackageById(this.screeningToEdit.searchPackageId).pipe(take(1), tap((pkg: SearchPackage[]) => {
          // let pgg: SearchPackage = pkg[0];
          this.appliedPackage = Object.assign(new SearchPackage(), pkg[0]);
          this.appliedPackage.searches = this.appliedPackage.searches.map(s => {
            return Object.assign(new SearchRecord(), s);
          });

          this.searches.GetClientSearchPackageOverride(this.screeningToEdit.clientId, this.appliedPackage.id).pipe(
            take(1),tap((scc: ClientPackagePricing) => {
                if (scc != null) {
                  this.clientPricingModel = scc;
                }
              })).subscribe();
        })).subscribe();
      })
  }

  getRequestingUser(userId : number) {
    //we pull this from a view hinged to CRA data, so we have to specify the c. to avoid sql errors
    this.users.userFilter = new UserFilter();
    this.users.userFilter.userId = userId;
    // this.users.FetchUserList(this.users.userFilter);
    // this.users.usersLoaded.subscribe(r => {
    //   this.requestingUser = this.users.users.filter(r => r.id == userId)[0];
    // })
  }

  public hasUnverifiedIncome: boolean;
  handleUnverIncome(event: boolean) 
  {
    //RIQ-4730: gotta pipe this down into the recdec component due to the way screening loads
    //if we are showing the DIV banner, we care about unverified income
    if(this.showDIVBanner) {
      this.hasUnverifiedIncome = event;  
      console.log('setting unverified income to ', event);
    }
    else
    {
      this.hasUnverifiedIncome = false;
    }
    
    //this ensures that on load, the groups get the flag and restrict the DD
    if(this.groups.groupScreenings && this.groups.groupScreenings.length > 0)
    {
      this.groups.groupScreenings.forEach(gs => {
        gs.hasUnverifiedIncome = event;
      });
    }
  }

  printReport() {
    // Set the print report flag, nav to the report and call window.print
    this.appData.GetReportPDF(this.screeningToEdit.invitationId).subscribe((scc:any)=>{
      this.toast.info('Your report pdf is on its way! Please feel free to continue working and it will automatically download.','Report PDF',{ closeButton: true, timeOut : 60000, tapToDismiss : true, progressBar : true, progressAnimation : 'increasing'});
      this.appData.printReport = new PrintQueueRequest(`${this.screeningToEdit.applicantFirstName + this.screeningToEdit.applicantLastName}`);
      
    },(err: any)=>{
      this.toast.error('We ran into a problem generating your report pdf.','Report PDF Error') 
    })
    // this.viewReport();
  }


  viewReport() {
    this.screening.GetReportViewToken(this.screeningToEdit.id).subscribe((res : any) => {
      if(res) {
        let fullViewLink = `${res.reportLink}`;
        window.open(fullViewLink, '_blank');
      } else {
        this.toast.error('Error loading report!', '', { closeButton: true, disableTimeOut: true })
      }
    },
    (error) => {
      this.toast.error('Error loading report!', '', { closeButton: true, disableTimeOut: true })

    })
  }

  searchAdded(event : SearchRecord){
    this.searches.addSearchToReport(this.screeningToEdit.id, event.id).subscribe(result => {
      this.toast.success('search added to report');
      this.toast.warning()

      this.screening.FetchScreeningAdditionalData(this.screeningToEdit.id).subscribe((rep:ScreeningAdditionalData[])=>{
        this.screeningToEdit.additionalData = [];
        rep.forEach(element => {
          this.screeningToEdit.additionalData.push(Object.assign(new ScreeningAdditionalData(),element))
        });
      },(err:any)=>{
        this.toast.warning('There was an error reloading your search results list.Please refresh the page to get your new search.','Error Refreshing Searches')
      })     
    },
    (error) => {
      //the search failed to save...
      this.toast.error('Search failed to add to report!', '', { closeButton: true, disableTimeOut: true });
    });  
  }

  addSearch(){
    this.modalRef = this.modalService.open(SearchAddDialogComponent, { centered: true, size: 'lg' })
    this.modalRef.componentInstance.name = 'SearchAddDialogComponent';
    let searchToAdd = new SearchRecord();
    this.modalRef.componentInstance.searchAdded.subscribe((scc: SearchRecord) => this.searchAdded(scc));
    this.modalRef.componentInstance.search = searchToAdd;
    this.modalRef.componentInstance.existingPackage = this.appliedPackage;
    this.modalRef.componentInstance.clientPackageOverrides = this.clientPricingModel;
    this.modalRef.componentInstance.packageEditMode = false;
    this.modalRef.componentInstance.additionalData = this.screeningToEdit.additionalData;
  }


  viewPackage() {
    if(this.auth.UserInRole('CRA') || this.auth.UserInRole('Admin')) {
      //get the pkg id, then reroute:
      let pkg = this.clients.loggedInUserPackages.filter(p => {return p.name.toString() == this.screeningToEdit.additionalData[0].packageName})[0];
      this.location.navigateByUrl(`packages/review/${pkg.id}`);
    }
  }

  editScreening() {
    const modalRef = this.modalService.open(ScreeningEditComponent, { centered: true, size: 'xl'});
    modalRef.componentInstance.name = 'ScreeningEditComponent';
    modalRef.componentInstance.screeningId = this.screeningId;
    modalRef.componentInstance.argyleData = this.screeningToEdit.argyleData;
  }

  initiateDispute() {
    if (this.screeningToEdit.hasDispute && this.existingDispute) {
      // View existing dispute
      this.openDisputeModal(this.existingDispute);
    } else if (this.screeningToEdit.hasDispute && !this.existingDispute) {
      // Has dispute but not loaded yet, fetch it first
      this.disputeService.getDisputeByScreeningId(this.screeningId).subscribe(
        (dispute: ConsumerDispute) => {
          this.existingDispute = dispute;
          this.openDisputeModal(dispute);
        },
        (error) => {
          this.toast.error('Error loading dispute details', '', { closeButton: true, disableTimeOut: true });
        }
      );
    } else {
      // Create new dispute
      this.openDisputeModal(null);
    }
  }

  private openDisputeModal(existingDispute: ConsumerDispute) {
    const dispoModal = this.modalService.open(DisputeModalComponent, { centered: true, size: 'lg' })
    dispoModal.componentInstance.name = 'DisputeModal';
    dispoModal.componentInstance.screeningId = this.screeningId;
    dispoModal.componentInstance.reportNumber = this.screeningToEdit.invitationId;
    dispoModal.componentInstance.disputedScreening = this.screeningToEdit;
    
    if (existingDispute) {
      dispoModal.componentInstance.existingDispute = existingDispute;
    }

    // Listen for modal close and refresh dispute data if a new one was created
    dispoModal.result.then(() => {
      if (this.screeningToEdit.hasDispute && !this.existingDispute) {
        // A new dispute was created, load it
        this.disputeService.getDisputeByScreeningId(this.screeningId).subscribe(
          (dispute: ConsumerDispute) => {
            this.existingDispute = dispute;
          },
          (error) => {
            console.error('Error loading newly created dispute:', error);
          }
        );
      }
    }).catch(() => {
      // Modal dismissed (cancelled)
    });
  }

  openEmailPrompt() {
    window.open(`mailto: ${this.requestingUser.email}`);
  }

  GoToTNT() {
    window.open(`https://login.tenanttech.com/residents/load_applicant_by_report_id/${this.screeningToEdit.invitationId}`,"_blank");
  }

  // RIQ-4642: Open sibling screening report in new tab (updated for multiple siblings)
  openSiblingReport(sibling: ScreeningLight): void {
    if (sibling) {
      const url = `/screenings/review/${sibling.screeningId}`;
      window.open(url, '_blank');
    }
  }

  openSupportIssue(): void {
    //if we don't have an active support issue, create one
    
    let supportIssue: SupportIssue = new SupportIssue();
    supportIssue.reportNumber = this.screeningToEdit.invitationId;
    supportIssue.status = SupportIssueStatus.Open;
    supportIssue.id = 0;
    supportIssue.description = "";
    
    this.modalRef = this.modalService.open(IssueDialogComponent, { centered: true, size: 'xl' });
    this.modalRef.componentInstance.name = 'OpenSupportIssue';
    this.modalRef.componentInstance.issue = supportIssue;

  }

  updateScrnView(event: any){
    console.info('Got an update',event);
  }    

  openGridSettings(): void {
    this.modalRef = this.modalService.open(GridSettingsSummaryComponent, { centered: true, size: 'xl' });
    this.modalRef.componentInstance.name = 'GridSettingsSummary';
    this.modalRef.componentInstance.screening = this.screeningToEdit;
  }
}